import { ColumnDef } from '@tanstack/react-table'
import { TFunction } from 'i18next'
import { ListUser, Roles } from '~/shared/api/services/users/types'
import {
  formatDate,
  formatTime,
} from '~/shared/lib/helper-functions/date-format'

export const getColumns = (t: TFunction): ColumnDef<ListUser>[] => [
  { header: 'name', accessorKey: 'name' },
  { header: 'email', accessorKey: 'email' },
  {
    header: 'role',
    accessorKey: 'roles',
    cell: ({ getValue }) => {
      const data = getValue() as Roles[]
      return data.map((el) => el.name).join(', ')
    },
  },
  {
    header: 'lastLoginAt',
    accessorKey: 'lastLoginAt',
    cell: ({ getValue }) => {
      const lastLoginAt = getValue() as ListUser['lastLoginAt']

      if (!lastLoginAt) {
        return '—'
      }

      return `${formatDate(lastLoginAt)} ${formatTime(lastLoginAt)}`
    },
  },
  {
    header: 'status',
    accessorKey: 'enabled',
    cell: ({ getValue }) => t(getValue() ? 'userActive' : 'userBlocked'),
  },
]
